import { useMemo } from 'react';
import { MealItemSelectors } from '../../containers/MealItemSelectors/MealItemSelectors';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { ComboItem } from '../ComboItem/ComboItem';
import { IResponseProductSize } from 'src/types/products';
import { getTranslate } from 'src/utils/helpers';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { IResponseComboGroupWithItems, IResponseComboItem } from '~/types/combo';
import { PRODUCT_TYPE } from '~/types/product';
import { productUtils } from '~/utils/productUtils';
import './style.scss';

interface IProps {
  group: IResponseComboGroupWithItems;
  comboSize?: IResponseProductSize | null;
}

const MealComboGroup: React.FC<IProps> = (props: IProps): JSX.Element => {
  const { name, items } = props.group;

  const selectedItem = useMemo((): IResponseComboItem | undefined => items.find((item) => item.is_selected), [items]);

  const units = useMemo(() => productUtils.getComboItemUnits(selectedItem), [selectedItem]);

  const selectedItemDescription = useMemo((): string => {
    return [...units, getTranslate(selectedItem?.description)].filter(Boolean).join(' • ');
  }, [units, selectedItem]);

  return (
    <div className="d-flex flex-column">
      <p className="product-meal-combo-group-block__title mb-4">{getTranslate(name)}</p>

      <ScrollableBlock direction="horizontal" showScrollbar scrollbarSize="small" className="product-meal-combo-group-block__scroll">
        <ul className="d-flex flex-row gap-20">
          {items.map((item, index) => (
            <ComboItem
              key={productUtils.getMealItemKey(item, index)}
              type={PRODUCT_TYPE.MEAL_COMBO}
              item={item}
              onSelectItem={orderProductModalStore.onSelectMealItem}
            />
          ))}
        </ul>
      </ScrollableBlock>

      {selectedItemDescription ? (
        <p className="product-meal-combo-group-block__item-description letter-spacing-5 text-break mt-4 mb-6">{selectedItemDescription}</p>
      ) : null}

      {selectedItem ? <MealItemSelectors item={selectedItem} /> : null}
    </div>
  );
};

export default MealComboGroup;
